// src/features/resources/services/resourceService.js
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  getDocs,
  query,
  where,
  orderBy,
  getDoc,
  serverTimestamp
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { db } from "../firebase/config";
import { v4 as uuidv4 } from "uuid";

const resourcesCollection = collection(db, "resources");

export const uploadResourceFile = async (userId, file) => {
  if (!file) return { url: "", path: "" };
  const storage = getStorage();
  const ext = file.name.split('.').pop();
  const filename = `${uuidv4()}.${ext}`;
  const filePath = `resources/${userId}/${filename}`;
  const storageRef = ref(storage, filePath);
  await uploadBytes(storageRef, file);
  const url = await getDownloadURL(storageRef);
  return { url, path: filePath };
};

export const createResource = async (resource) => {
  // resource must include: userId, title, folderId, type, fileUrl (can be ""), visibility, subjectId, grade
  const docRef = await addDoc(resourcesCollection, {
    ...resource,
    createdAt: serverTimestamp()
  });
  return { id: docRef.id, ...resource };
};

export const updateResource = async (resourceId, updates) => {
  await updateDoc(doc(db, "resources", resourceId), updates);
};

export const deleteResource = async (resourceId) => {
  // Delete metadata and attempt to delete file if filePath present
  const resourceDoc = await getDoc(doc(db, "resources", resourceId));
  if (!resourceDoc.exists()) return;
  const data = resourceDoc.data();
  if (data.filePath) {
    try {
      const storage = getStorage();
      const fileRef = ref(storage, data.filePath);
      await deleteObject(fileRef);
    } catch (err) {
      // ignore deletion errors (file might already be absent)
      console.warn("Failed deleting file from storage:", err);
    }
  }
  await deleteDoc(doc(db, "resources", resourceId));
};

export const fetchResourcesForFolder = async (folderId) => {
  const q = query(resourcesCollection, where("folderId", "==", folderId), orderBy("createdAt", "desc"));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const fetchAllResources = async () => {
  const q = query(resourcesCollection, orderBy("createdAt", "desc"));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const fetchResourceById = async (resourceId) => {
  const d = await getDoc(doc(db, "resources", resourceId));
  return d.exists() ? { id: d.id, ...d.data() } : null;
};
